<template>
  <div>
    <h2><em>页面开发中...请耐心等待。</em></h2>
  </div>
</template>

<script>

  export default {
    data() {
      return {

      }
    },
    methods: {
    },
    mounted() {
    }

  }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/Developing/P9999.vue